module.exports = __webpack_public_path__ + "img/hover_card_medicaid_claims.7317a70d.svg";